import {
  AddressSelectFormModel,
  FieldId,
  LawPersonAddress,
  LawPersonType,
  LegalPersonData,
  NaturalPersonData,
  getValueWhenPropertyIsAddressFields,
  getValueWhenPropertyIsString,
  isPolandCountrySelected,
} from '@gk/gk-modules';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ProxyType } from '../../components/proxy-details/proxy-details.model';
import { DateHelperUtil } from '../../utils/date-helper/date-helper.util';

export interface InvestorDetails {
  type: LawPersonType;
  naturalPersonData: NaturalPersonData;
  legalPersonData: LegalPersonData;
  idNumber: number;
  phoneNumber: number;
  email: string;
  birthDate: NgbDate;
  birthPlace: string;
  address: LawPersonAddress;
  epuapAddress: string;
  addressSelect?: AddressSelectFormModel;
  proxyType?: ProxyType;
}

export class InvestorDetailsRequestDto {
  constructor(
    public Nazwisko: string,
    public Imie: string,
    public Nazwa: string,
    public Pesel: string,
    public Nip: string,
    public Regon: string,
    public Telefon: number,
    public Email: string,
    public NrDowodu: number,
    public MiejscId: string,
    public Miejsc: string,
    public UlicaId: string,
    public Ulica: string,
    public KodId: string,
    public Kod: string,
    public Poczta: string,
    public Numer: string,
    public Numer2: string,
    public Typ: LawPersonType,
    public DataUrodzenia: string,
    public MiejsceUrodzenia: string,
    public SkrzynkaEpuap: string,
    public GminaNrGus: FieldId,
    public MiejscGusSym: FieldId,
    public UlicaGusSym: FieldId,
    public RodzPet: string,
    public RodzajPelnomocnika?: ProxyType,
    public KrajId?: FieldId,
  ) {}

  static fromAppToApi(
    investorDetails: InvestorDetails,
  ): InvestorDetailsRequestDto {
    const petentData: NaturalPersonData & LegalPersonData = {
      ...investorDetails.naturalPersonData,
      ...investorDetails.legalPersonData,
    };
    const petentAddress: LawPersonAddress = investorDetails?.address;
    const petentAddressSelect = investorDetails?.addressSelect;
    const polandCountrySelected = isPolandCountrySelected(
      petentAddressSelect?.country,
    );
    const placeId =
      petentAddress && !petentAddressSelect
        ? getValueWhenPropertyIsAddressFields(petentAddress.place)
        : undefined;
    const place =
      petentAddress && !petentAddressSelect
        ? getValueWhenPropertyIsString(petentAddress.place)
        : petentAddressSelect && !polandCountrySelected
          ? petentAddressSelect.place
          : undefined;
    const streetId =
      petentAddress && !petentAddressSelect
        ? getValueWhenPropertyIsAddressFields(petentAddress.street)
        : undefined;
    const street =
      petentAddress && !petentAddressSelect
        ? getValueWhenPropertyIsString(petentAddress.street)
        : petentAddressSelect && !polandCountrySelected
          ? petentAddressSelect.street
          : undefined;
    const postalCodeId =
      petentAddress && !petentAddressSelect
        ? getValueWhenPropertyIsAddressFields(petentAddress.postalCode)
        : getValueWhenPropertyIsAddressFields(petentAddressSelect?.postalCode);
    const postalCode =
      petentAddress && !petentAddressSelect
        ? getValueWhenPropertyIsString(petentAddress.postalCode)
        : petentAddressSelect && !polandCountrySelected
          ? getValueWhenPropertyIsString(petentAddressSelect.postalCode)
          : undefined;
    const postOffice =
      petentAddress && !petentAddressSelect
        ? petentAddress.postOffice
        : petentAddressSelect && !polandCountrySelected
          ? petentAddressSelect.postOffice
          : undefined;
    const buildingNumber =
      petentAddress && !petentAddressSelect
        ? petentAddress.buildingNumber
        : petentAddressSelect.buildingNumber;
    const localNumber =
      petentAddress && !petentAddressSelect
        ? petentAddress.localNumber
        : petentAddressSelect.localNumber;
    const countryId = petentAddressSelect
      ? petentAddressSelect.country
      : undefined;
    const placeGus =
      petentAddressSelect && polandCountrySelected
        ? petentAddressSelect.place
        : undefined;
    const streetGus =
      petentAddressSelect && polandCountrySelected
        ? petentAddressSelect.street
        : undefined;

    switch (investorDetails.type) {
      case LawPersonType.Legal:
        return new this(
          undefined,
          undefined,
          petentData.name,
          undefined,
          petentData.nip,
          petentData.regon,
          investorDetails.phoneNumber,
          investorDetails.email,
          undefined,
          placeId,
          place,
          streetId,
          street,
          postalCodeId,
          postalCode,
          postOffice,
          buildingNumber,
          localNumber,
          investorDetails.type,
          undefined,
          undefined,
          investorDetails.epuapAddress,
          undefined, // TODO: set to undefined due to API issues. To be restored in the future: petentAddressSelect ? petentAddressSelect.community?.gusNumber : undefined,
          placeGus,
          streetGus,
          `${petentData.typeId}`,
          investorDetails.proxyType,
          countryId,
        );
      case LawPersonType.Natural:
        return new this(
          petentData.lastName,
          petentData.firstName,
          undefined,
          petentData.pesel,
          undefined,
          undefined,
          investorDetails.phoneNumber,
          investorDetails.email,
          investorDetails.idNumber,
          placeId,
          place,
          streetId,
          street,
          postalCodeId,
          postalCode,
          postOffice,
          buildingNumber,
          localNumber,
          investorDetails.type,
          DateHelperUtil.ngbDateToApiDateTime(investorDetails.birthDate),
          investorDetails.birthPlace,
          investorDetails.epuapAddress,
          undefined, // TODO: set to undefined due to API issues. To be restored in the future: petentAddressSelect ? petentAddressSelect.community?.gusNumber : undefined,
          placeGus,
          streetGus,
          `${petentData.typeId}`,
          investorDetails.proxyType,
          countryId,
        );
    }
  }
}
